import { Component, EventEmitter, Inject, Output } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatSelectModule } from '@angular/material/select'
import { NgClass, SlicePipe } from '@angular/common'
import { SugestaoAgrupamentoService } from '../../../core/services/sugestao-agrupamento/sugestao-agrupamento.service'
import { ServiceAdditionalService } from '../../../core/services/service/service-additional/service-additional.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { ContratoCoordenadorService } from '../../../core/services/contrato-coordenador/contrato-coordenador.service'
import { StretchTypeService } from '../../../core/services/stretch/stretch-type/stretch-type.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ModalMoverPassageiroComponent } from './modal-mover-passageiro.component'
import { ModalTrocarVeiculoComponent, VeiculoTroca } from './modal-trocar-veiculo.component'
import { ModalObservacaoGrupoComponent } from './modal-observacao-grupo.component'
import { ModalServicoAdicionalGrupoComponent, ServicoAdicionalItem } from './modal-servico-adicional-grupo.component'
import { ItemProposalCreateFormComponent } from '../../proposal/item-proposal-create/item-proposal-create-form/item-proposal-create-form.component'
import { ItemProposalEditFormComponent } from '../../proposal/item-proposal-edit/item-proposal-edit-form/item-proposal-edit-form.component'
import { ProposalItemService } from '../../../core/services/proposal/proposal-item/proposal-item.service'
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component'
import moment from 'moment'

type FlowState = 'idle' | 'generated' | 'review'

interface PassageiroUI {
  id: string
  nome: string
  hora: string
  data?: string
  speaker: boolean
  multiploTrecho: boolean
  repetida: boolean
  origemTipo: string | null
  origemAeroSigla: string | null
  origemLogradouro: string | null
  origemNumero: string | null
  origemComplemento: string | null
  origemBairro: string | null
  origemCidade: string | null
  destinoTipo: string | null
  destinoAeroSigla: string | null
  destinoLogradouro: string | null
  destinoNumero: string | null
  destinoComplemento: string | null
  destinoBairro: string | null
  destinoCidade: string | null
  rotaDivergente: boolean
}

interface GrupoUI {
  itemPropostaId: number
  itemPropostaOriginalId: number | null
  isDuplicado: boolean
  individual: boolean
  motivoIndividual: string | null
  itemContratoId: string | null
  tipoVeiculoDescricao: string
  capacidade: number
  tipoTrechoId: number
  tipoTrechoDescricao: string
  data: string
  horaInicio: string
  horaFinal: string
  voo: string | null
  totalPassageiros: number
  passageiros: PassageiroUI[]
  observacao: string | null
  servicosAdicionais: ServicoAdicionalItem[]
  origemCidade: string | null
  origemEstado: string | null
  origemDescricao: string | null
  destinoCidade: string | null
  destinoEstado: string | null
  destinoDescricao: string | null
  rotaDivergente: boolean
  rotaPassageiros: string | null
  motivoDivergencia: string | null
  passageirosDivergentes: number
}

interface CoordenadorTrecho {
  tipoTrechoId: number
  tipoTrechoDescricao: string
  coordenadorIds: number[]
}

@Component({
  selector: 'modal-sugestao-agrupamento',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSelectModule,
    NgClass,
    SlicePipe,
    ItemProposalEditFormComponent,
    DialogConfirmComponent,
  ],
  templateUrl: './modal-sugestao-agrupamento.component.html',
  styleUrl: './modal-sugestao-agrupamento.component.scss',
})
export class ModalSugestaoAgrupamentoComponent {
  @Output() response = new EventEmitter<boolean>()

  state: FlowState = 'idle'
  janelaMinutos = 60
  agruparPorOrigem = true
  agruparPorDestino = true
  agruparPorVoo = false
  loading = false

  grupos: GrupoUI[] = []
  semCorrespondencia: any[] = []
  confirmedGroups: any[] = []
  podeAjustarValores = false

  catalogoServicos: any[] = []
  coordenadoresList: any[] = []
  tipoTrechoList: any[] = []
  coordenadoresPorTrecho: CoordenadorTrecho[] = []
  necessidadeCoordenadores: { necessitaCoordenador: boolean; tiposTrecho: any[] } | null = null
  salvandoCoordenadores = false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalSugestaoAgrupamentoComponent>,
    private dialog: MatDialog,
    private sugestaoService: SugestaoAgrupamentoService,
    private serviceAdditionalService: ServiceAdditionalService,
    private employeeService: EmployeeService,
    private contratoCoordenadorService: ContratoCoordenadorService,
    private stretchTypeService: StretchTypeService,
    private proposalItemService: ProposalItemService,
    private snackbar: SnackbarCustomService,
    private sanitizer: DomSanitizer,
  ) {}

  get contratoId(): any {
    return this.data?.id
  }

  get temServicoCoorden(): boolean {
    return this.grupos.some(g =>
      g.servicosAdicionais.some(s => s.descricao.toLowerCase().includes('coorden')),
    )
  }

  gerar() {
    this.loading = true
    this.coordenadoresPorTrecho = []
    this.coordenadoresList = []
    this.necessidadeCoordenadores = null
    const janelaMinutos = this.janelaMinutos ?? 0
    this.sugestaoService.gerar(this.contratoId, janelaMinutos, this.agruparPorOrigem, this.agruparPorDestino, this.agruparPorVoo).subscribe({
      next: (res: any) => {
        this.grupos = (res.data?.grupos ?? []).map((g: any) => ({
          ...g,
          isDuplicado: g.isDuplicado ?? false,
          individual: g.individual ?? false,
          motivoIndividual: g.motivoIndividual ?? null,
          itemPropostaOriginalId: g.itemPropostaOriginalId ?? null,
          itemContratoId: g.itemContratoId ?? null,
          tipoTrechoDescricao: g.tipoTrechoDescricao ?? '',
          passageiros: (g.passageiros ?? []).map((p: any) => ({
            id: p.id,
            nome: p.nome,
            hora: p.hora,
            data: p.data,
            speaker: p.speaker ?? false,
            multiploTrecho: p.multiploTrecho ?? false,
            repetida: p.repetida ?? false,
            origemTipo: p.origemTipo || null,
            origemAeroSigla: p.origemAeroSigla || null,
            origemLogradouro: p.origemLogradouro || null,
            origemNumero: p.origemNumero || null,
            origemComplemento: p.origemComplemento || null,
            origemBairro: p.origemBairro || null,
            origemCidade: p.origemCidade || null,
            destinoTipo: p.destinoTipo || null,
            destinoAeroSigla: p.destinoAeroSigla || null,
            destinoLogradouro: p.destinoLogradouro || null,
            destinoNumero: p.destinoNumero || null,
            destinoComplemento: p.destinoComplemento || null,
            destinoBairro: p.destinoBairro || null,
            destinoCidade: p.destinoCidade || null,
            rotaDivergente: p.rotaDivergente ?? false,
          })),
          observacao: g.observacao ?? null,
          servicosAdicionais: [],
          origemCidade: g.origemCidade || null,
          origemEstado: g.origemEstado || null,
          origemDescricao: g.origemDescricao || null,
          destinoCidade: g.destinoCidade || null,
          destinoEstado: g.destinoEstado || null,
          destinoDescricao: g.destinoDescricao || null,
          rotaDivergente: g.rotaDivergente ?? false,
          rotaPassageiros: g.rotaPassageiros ?? null,
          motivoDivergencia: g.motivoDivergencia ?? null,
          passageirosDivergentes: g.passageirosDivergentes ?? 0,
        }))
        this.semCorrespondencia = res.data?.semCorrespondencia ?? []
        this.state = 'generated'
        this.loading = false
        this.loadCatalogos()
      },
      error: () => {
        this.snackbar.error('Não foi possível gerar a sugestão.')
        this.loading = false
      },
    })
  }

  private loadCatalogos() {
    if (this.catalogoServicos.length === 0) {
      this.serviceAdditionalService.listServiceAdditional().subscribe({
        next: (res: any) => {
          this.catalogoServicos = (res.data ?? []).map((item: any) => ({
            ...item,
            valorUnitario: item.valorVenda ?? item.valor ?? 0,
          }))
        },
      })
    }
    if (this.tipoTrechoList.length === 0) {
      this.stretchTypeService.listStretchType().subscribe({
        next: (res: any) => { this.tipoTrechoList = res.data ?? [] },
      })
    }
  }

  private loadCoordenadores() {
    if (this.coordenadoresList.length === 0) {
      this.employeeService.listCoordenadores().subscribe({
        next: (res: any) => { this.coordenadoresList = res.data ?? [] },
      })
    }
  }

  buildCoordenadoresPorTrecho() {
    // Apenas grupos que têm ao menos um serviço de coordenação
    const gruposCoorden = this.grupos.filter(g =>
      g.servicosAdicionais.some(s => s.descricao.toLowerCase().includes('coorden')),
    )

    this.contratoCoordenadorService.getByContrato(this.contratoId).subscribe({
      next: (r: any) => {
        const ativos: any[] = r.data ?? []
        const ativoMap = new Map<number, { desc: string; ids: number[] }>()
        for (const trecho of ativos) {
          ativoMap.set(trecho.tipoTrechoId, {
            desc: trecho.tipoTrechoDescricao ?? '',
            ids: (trecho.coordenadores ?? []).map((c: any) => c.coordenadorId),
          })
        }
        const trechoMap = new Map<number, CoordenadorTrecho>()
        for (const grupo of gruposCoorden) {
          if (!grupo.tipoTrechoId || trechoMap.has(grupo.tipoTrechoId)) continue
          const ativo = ativoMap.get(grupo.tipoTrechoId)
          const existing = this.coordenadoresPorTrecho.find(c => c.tipoTrechoId === grupo.tipoTrechoId)
          // Prioridade: descrição do gerar (backend) > getByContrato > tipoTrechoList > fallback
          const desc = grupo.tipoTrechoDescricao
            || ativo?.desc
            || this.tipoTrechoList.find((t: any) => t.id === grupo.tipoTrechoId)?.descricao
            || `Tipo ${grupo.tipoTrechoId}`
          trechoMap.set(grupo.tipoTrechoId, {
            tipoTrechoId: grupo.tipoTrechoId,
            tipoTrechoDescricao: desc,
            // Preserva seleção atual do usuário; só usa backend se for entrada nova
            coordenadorIds: existing?.coordenadorIds ?? ativo?.ids ?? [],
          })
        }
        this.coordenadoresPorTrecho = Array.from(trechoMap.values())
      },
      error: () => {
        const trechoMap = new Map<number, CoordenadorTrecho>()
        for (const grupo of gruposCoorden) {
          if (!grupo.tipoTrechoId || trechoMap.has(grupo.tipoTrechoId)) continue
          const desc = grupo.tipoTrechoDescricao
            || this.tipoTrechoList.find((t: any) => t.id === grupo.tipoTrechoId)?.descricao
            || `Tipo ${grupo.tipoTrechoId}`
          trechoMap.set(grupo.tipoTrechoId, {
            tipoTrechoId: grupo.tipoTrechoId,
            tipoTrechoDescricao: desc,
            coordenadorIds: [],
          })
        }
        this.coordenadoresPorTrecho = Array.from(trechoMap.values())
      },
    })
  }

  openServicoDialog(grupo: GrupoUI) {
    const ref = this.dialog.open(ModalServicoAdicionalGrupoComponent, {
      data: { catalogo: this.catalogoServicos, selecionados: grupo.servicosAdicionais },
      width: '480px',
      maxHeight: '80vh',
    })
    ref.afterClosed().subscribe((result: ServicoAdicionalItem[] | null) => {
      if (result === null) return
      grupo.servicosAdicionais = result
      if (this.temServicoCoorden) {
        this.loadCoordenadores()
        this.buildCoordenadoresPorTrecho()
      } else {
        this.coordenadoresPorTrecho = []
        this.coordenadoresList = []
      }
    })
  }

  removerServico(grupo: GrupoUI, srv: ServicoAdicionalItem) {
    grupo.servicosAdicionais = grupo.servicosAdicionais.filter(s => s.servicoAdicionalId !== srv.servicoAdicionalId)
    if (this.temServicoCoorden) {
      this.buildCoordenadoresPorTrecho()
    } else {
      this.coordenadoresPorTrecho = []
      this.coordenadoresList = []
    }
  }

  confirmar() {
    const grupos = this.grupos
      .filter(g => g.passageiros.length > 0)
      .map(g => ({
        itemPropostaId: g.itemPropostaId,
        passageiroIds: g.passageiros.map(p => p.id),
        observacao: g.observacao || null,
        servicosAdicionais: g.servicosAdicionais.length > 0 ? g.servicosAdicionais : undefined,
      }))
    const coordenadores = this.coordenadoresPorTrecho
      .filter(c => c.coordenadorIds.length > 0)
      .map(c => ({
        tipoTrechoId: c.tipoTrechoId,
        coordenadores: c.coordenadorIds.map(id => ({ coordenadorId: id })),
      }))
    this.loading = true
    this.sugestaoService.confirmar(this.contratoId, grupos, coordenadores.length > 0 ? coordenadores : undefined).subscribe({
      next: (res: any) => {
        this.loading = false
        this.snackbar.success(res?.message || 'Agrupamento confirmado com sucesso!')
        const data = res?.data
        if (data?.podeAjustarValores) {
          this.confirmedGroups = data.grupos ?? []
          this.podeAjustarValores = true
          this.state = 'review'
        } else {
          this.response.emit(true)
          this.dialogRef.close()
        }
        this.verificarNecessidadeCoordenadores()
      },
      error: () => {
        this.snackbar.error('Não foi possível confirmar o agrupamento.')
        this.loading = false
      },
    })
  }

  private verificarNecessidadeCoordenadores() {
    this.contratoCoordenadorService.getNecessidade(this.contratoId).subscribe({
      next: (res: any) => {
        const data = res?.data ?? res
        if (data?.necessitaCoordenador) {
          this.necessidadeCoordenadores = data
          this.loadCoordenadores()
          if (this.coordenadoresPorTrecho.length === 0) {
            this.coordenadoresPorTrecho = (data.tiposTrecho ?? []).map((t: any) => ({
              tipoTrechoId: t.tipoTrechoId,
              tipoTrechoDescricao: t.tipoTrechoDescricao,
              coordenadorIds: [],
            }))
          }
        }
      },
    })
  }

  salvarCoordenadores() {
    const pendentes = this.coordenadoresPorTrecho.filter(c => c.coordenadorIds.length > 0)
    if (!pendentes.length) return
    this.salvandoCoordenadores = true
    let concluidos = 0
    for (const c of pendentes) {
      this.contratoCoordenadorService.definir({
        contratoId: this.contratoId,
        tipoTrechoId: c.tipoTrechoId,
        coordenadores: c.coordenadorIds.map(id => ({ coordenadorId: id })),
      }).subscribe({
        next: () => {
          concluidos++
          if (concluidos === pendentes.length) {
            this.salvandoCoordenadores = false
            this.necessidadeCoordenadores = null
            this.snackbar.success('Coordenadores associados com sucesso!')
          }
        },
        error: () => {
          this.salvandoCoordenadores = false
          this.snackbar.error('Erro ao salvar coordenadores.')
        },
      })
    }
  }

  editGrupo(grupo: any) {
    this.loading = true
    this.proposalItemService.getProposalItembyId(grupo.itemPropostaId).subscribe({
      next: (res: any) => {
        this.loading = false
        const proposalInfo = {
          statusPropostaId: this.data.statusPropostaId ?? 4,
          clienteId: this.data.idCliente ?? this.data.clienteId ?? 0,
          subClienteId: this.data.subClienteId ?? 0,
        }
        const dialogRef = this.dialog.open(ItemProposalEditFormComponent, {
          enterAnimationDuration: '100ms',
          exitAnimationDuration: '100ms',
          maxWidth: '100vw',
          width: '100vw',
          maxHeight: '100vh',
          height: '100vh',
          panelClass: 'dialog-fullscreen',
          data: { edit: true, item: res.data, proposalInfo, forceEditable: true },
        })
        dialogRef.componentInstance.response.subscribe(() => {
          this.snackbar.success('Item de proposta atualizado com sucesso!')
        })
      },
      error: () => {
        this.loading = false
        this.snackbar.error('Não foi possível carregar o item de proposta.')
      },
    })
  }

  concluir() {
    this.response.emit(true)
    this.dialogRef.close()
  }

  onRemove(grupo: GrupoUI, passageiro: PassageiroUI) {
    this.removePassengerLocal(grupo, passageiro.id)
  }

  openMoverDialog(grupo: GrupoUI, passageiro: PassageiroUI) {
    const otherGroups = this.grupos.filter(g => g !== grupo)
    const ref = this.dialog.open(ModalMoverPassageiroComponent, {
      data: { passageiro, grupos: otherGroups },
      width: '480px',
      maxHeight: '80vh',
    })
    ref.afterClosed().subscribe((toGrupo: GrupoUI | null) => {
      if (!toGrupo) return
      this.movePassengerLocal(grupo, passageiro.id, toGrupo)
    })
  }

  openObservacaoDialog(grupo: GrupoUI) {
    const ref = this.dialog.open(ModalObservacaoGrupoComponent, {
      data: { grupo },
      width: '480px',
      maxHeight: '80vh',
    })
    ref.afterClosed().subscribe((result: { observacao: string } | null) => {
      if (!result) return
      grupo.observacao = result.observacao || null
    })
  }

  openMoverParaGrupoDialog(passageiro: any) {
    const ref = this.dialog.open(ModalMoverPassageiroComponent, {
      data: { passageiro, grupos: this.grupos },
      width: '480px',
      maxHeight: '80vh',
    })
    ref.afterClosed().subscribe((toGrupo: GrupoUI | null) => {
      if (!toGrupo) return
      this.semCorrespondencia = this.semCorrespondencia.filter(p => p.id !== passageiro.id)
      toGrupo.passageiros = [
        ...toGrupo.passageiros,
        {
          id: passageiro.id,
          nome: passageiro.nome,
          hora: passageiro.hora,
          data: passageiro.data,
          speaker: passageiro.speaker ?? false,
          multiploTrecho: passageiro.multiploTrecho ?? false,
          repetida: passageiro.repetida ?? false,
          origemTipo: passageiro.origemTipo || null,
          origemAeroSigla: passageiro.origemAeroSigla || null,
          origemLogradouro: passageiro.origemLogradouro || null,
          origemNumero: passageiro.origemNumero || null,
          origemComplemento: passageiro.origemComplemento || null,
          origemBairro: passageiro.origemBairro || null,
          origemCidade: passageiro.origemCidade || null,
          destinoTipo: passageiro.destinoTipo || null,
          destinoAeroSigla: passageiro.destinoAeroSigla || null,
          destinoLogradouro: passageiro.destinoLogradouro || null,
          destinoNumero: passageiro.destinoNumero || null,
          destinoComplemento: passageiro.destinoComplemento || null,
          destinoBairro: passageiro.destinoBairro || null,
          destinoCidade: passageiro.destinoCidade || null,
          rotaDivergente: passageiro.rotaDivergente ?? false,
        },
      ]
      toGrupo.totalPassageiros = toGrupo.passageiros.length
    })
  }

  criarItemProposta(passageiro: any) {
    const dialogRef = this.dialog.open(ItemProposalCreateFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: {
        idClient: this.data.idCliente,
        period: {
          dataInicio: this.data.dataInicio,
          dataFim: this.data.dataFim,
        },
      },
    })
    dialogRef.componentInstance.response.subscribe((response: any) => {
      if (!response) return
      const model = this.mapItemProposalModel(response)
      this.proposalItemService.createProposalItemWithItinerariesPostProposal(model).subscribe({
        next: () => this.snackbar.success('Item de proposta criado com sucesso!'),
        error: (err: any) => this.snackbar.errorRequest(err),
      })
    })
  }

  private mapItemProposalModel(response: any) {
    return {
      propostaId: this.data.propostaId,
      tarifarioId: response.tarifarioId || null,
      tipoTarifarioId: response.tipoTarifarioId || null,
      perimetroUrbano: response.perimetroUrbano || null,
      origemId: response.origemId || 0,
      destinoId: response.destinoId || 0,
      tipoServicoId: response.tipoServicoId || null,
      servicoId: response.servicoId || null,
      tipoVeiculoId: response.tipoVeiculoId || null,
      tipoMotoristaId: response.tipoMotoristaId || null,
      numPessoas: response.numPessoas || 0,
      numVeiculos: response.numVeiculos || 0,
      valorUnitario: this.parseVal(response.vendaUnitario),
      valorTaxa: this.parseVal(response.valorTaxa),
      valorVenda: this.parseVal(response.vendaSemTaxa),
      valorComTaxa: this.parseVal(response.venda),
      valorKmVenda: this.parseVal(response.saleKmExtra),
      valorHoraVenda: this.parseVal(response.saleHoraExtra),
      isPermuta: response.isPermuta ? 'S' : 'N',
      isComissiona: response.isComisionado ? 'S' : 'N',
      isCortesia: response.isCortesia ? 'S' : 'N',
      dataInicio: response.dataInicio ? moment(response.dataInicio, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY') : null,
      horaInicio: this.toHHMMSS(response.horaInicio || ''),
      dataFinal: response.dataFinal ? moment(response.dataFinal, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY') : null,
      horaFinal: this.toHHMMSS(response.horaFinal || ''),
      taxa: Number(response.taxa) || 0,
      divisor: Number(response.divisor) || 0,
      comissao: Number(response.comissao) || 0,
      tipoDivisor: response.tipoComissao || null,
      observacao: response.observacao || '',
      itinerarios: (response.intinerarios || []).map((iti: any) => ({
        localParada: iti.localParada || '',
        cep: iti.cep || '',
        logradouro: iti.logradouro || '',
        numero: iti.numero || '',
        bairro: iti.bairro || '',
        complemento: iti.complemento || '',
        descricao: iti.descricao || '',
        cidade: iti.cidade || '',
        estado: iti.estado || '',
        latitude: iti.latitude || 0,
        longitude: iti.longitude || 0,
        trecho: iti.trecho || '',
        areaTarifario: iti.areaTarifario || '',
      })),
    }
  }

  private toHHMMSS(hora: string): string {
    if (!hora) return null as any
    const parts = hora.split(':')
    return parts.length === 3 ? hora : `${hora}:00`
  }

  private parseVal(value: any): number {
    if (typeof value === 'number') return value
    if (typeof value === 'string') {
      const n = parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
      return isNaN(n) ? 0 : n
    }
    return 0
  }

  private movePassengerLocal(from: GrupoUI, passageiroId: string, to: GrupoUI) {
    // eslint-disable-next-line eqeqeq
    const p = from.passageiros.find(p => p.id == passageiroId)
    if (!p) return

    // eslint-disable-next-line eqeqeq
    from.passageiros = from.passageiros.filter(p => p.id != passageiroId)
    to.passageiros = [...to.passageiros, { ...p }]
    from.totalPassageiros = from.passageiros.length
    to.totalPassageiros = to.passageiros.length
    this.updateGroupDateTime(from)
    this.updateGroupDateTime(to)
  }

  private openTrocarVeiculoDialog(
    veiculos: VeiculoTroca[],
    numPassageiros: number,
    onSelect: (v: VeiculoTroca) => void,
  ) {
    const ref = this.dialog.open(ModalTrocarVeiculoComponent, {
      data: { veiculos, numPassageiros },
      width: '900px',
      maxWidth: '92vw',
      maxHeight: '85vh',
    })
    ref.afterClosed().subscribe((veiculo: VeiculoTroca | null) => {
      if (!veiculo) return
      onSelect(veiculo)
    })
  }

  trocarVeiculo(grupo: GrupoUI) {
    this.loading = true
    const req$ = grupo.itemContratoId
      ? this.sugestaoService.getVeiculosTroca(grupo.itemContratoId)
      : this.sugestaoService.getVeiculosProposta(this.data.propostaId, grupo.passageiros.length)
    req$.subscribe({
      next: (res: any) => {
        this.loading = false
        const veiculos: VeiculoTroca[] = (res.data ?? []).map((v: any) => ({
          ...v,
          atual: v.itemPropostaId === grupo.itemPropostaId,
        }))
        this.openTrocarVeiculoDialog(veiculos, grupo.passageiros.length, (v) => {
          this.confirmarTrocaVeiculo(grupo, v)
        })
      },
      error: () => {
        this.loading = false
        this.snackbar.error('Não foi possível carregar os veículos disponíveis.')
      },
    })
  }

  private confirmarTrocaVeiculo(grupo: GrupoUI, veiculo: VeiculoTroca) {
    this.loading = true
    const passageiroIds = grupo.passageiros.map(p => p.id)
    this.sugestaoService.previewTrocaVeiculo({ novoItemPropostaId: veiculo.itemPropostaId, passageiroIds }).subscribe({
      next: (res: any) => {
        this.loading = false
        this.aplicarPreviewTrocaVeiculo(grupo, res.data)
      },
      error: (err: any) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  private aplicarPreviewTrocaVeiculo(grupo: GrupoUI, data: any) {
    grupo.itemPropostaId = data.itemPropostaId
    grupo.tipoVeiculoDescricao = data.tipoVeiculoDescricao
    grupo.capacidade = data.capacidade
    grupo.origemCidade = data.origemCidade || null
    grupo.origemEstado = data.origemEstado || null
    grupo.origemDescricao = data.origemDescricao || null
    grupo.destinoCidade = data.destinoCidade || null
    grupo.destinoEstado = data.destinoEstado || null
    grupo.destinoDescricao = data.destinoDescricao || null
    grupo.tipoTrechoId = data.tipoTrechoId
    grupo.tipoTrechoDescricao = data.tipoTrechoDescricao ?? ''
    grupo.data = data.data
    grupo.horaInicio = data.horaInicio
    grupo.horaFinal = data.horaFinal
    grupo.voo = data.voo || null
    grupo.totalPassageiros = data.totalPassageiros ?? (data.passageiros ?? []).length
    grupo.individual = data.individual ?? false
    grupo.motivoIndividual = data.motivoIndividual ?? null
    grupo.rotaDivergente = data.rotaDivergente ?? false
    grupo.rotaPassageiros = data.rotaPassageiros ?? null
    grupo.motivoDivergencia = data.motivoDivergencia ?? null
    grupo.passageirosDivergentes = data.passageirosDivergentes ?? 0
    grupo.passageiros = (data.passageiros ?? []).map((p: any) => ({
      id: p.id,
      nome: p.nome,
      hora: p.hora,
      data: p.data,
      speaker: p.speaker ?? false,
      multiploTrecho: p.multiploTrecho ?? false,
      repetida: p.repetida ?? false,
      origemTipo: p.origemTipo || null,
      origemAeroSigla: p.origemAeroSigla || null,
      origemLogradouro: p.origemLogradouro || null,
      origemNumero: p.origemNumero || null,
      origemComplemento: p.origemComplemento || null,
      origemBairro: p.origemBairro || null,
      origemCidade: p.origemCidade || null,
      destinoTipo: p.destinoTipo || null,
      destinoAeroSigla: p.destinoAeroSigla || null,
      destinoLogradouro: p.destinoLogradouro || null,
      destinoNumero: p.destinoNumero || null,
      destinoComplemento: p.destinoComplemento || null,
      destinoBairro: p.destinoBairro || null,
      destinoCidade: p.destinoCidade || null,
      rotaDivergente: p.rotaDivergente ?? false,
    }))
  }

  adicionarGrupo() {
    if (!this.grupos.length) return
    this.loading = true
    this.sugestaoService.getVeiculosProposta(this.data.propostaId).subscribe({
      next: (res: any) => {
        this.loading = false
        const veiculos: VeiculoTroca[] = res.data ?? []
        this.openTrocarVeiculoDialog(veiculos, 0, (v) => {
          this.grupos = [
            ...this.grupos,
            {
              itemPropostaId: v.itemPropostaId,
              itemPropostaOriginalId: null,
              isDuplicado: false,
              individual: false,
              motivoIndividual: null,
              itemContratoId: null,
              tipoVeiculoDescricao: v.tipoVeiculoDescricao,
              capacidade: v.capacidade,
              tipoTrechoId: 0,
              tipoTrechoDescricao: '',
              data: '',
              horaInicio: '',
              horaFinal: '',
              voo: null,
              totalPassageiros: 0,
              passageiros: [],
              observacao: null,
              servicosAdicionais: [],
              origemCidade: null,
              origemEstado: null,
              origemDescricao: null,
              destinoCidade: null,
              destinoEstado: null,
              destinoDescricao: null,
              rotaDivergente: false,
              rotaPassageiros: null,
              motivoDivergencia: null,
              passageirosDivergentes: 0,
            },
          ]
        })
      },
      error: () => {
        this.loading = false
        this.snackbar.error('Não foi possível carregar os veículos disponíveis.')
      },
    })
  }

  removerGrupo(grupo: GrupoUI) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Remover grupo',
        message: 'Deseja remover este grupo? Os passageiros voltarão para a lista sem correspondência.',
        confirmLabel: 'Remover',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return
      grupo.passageiros.forEach(p => {
        this.semCorrespondencia = [...this.semCorrespondencia, { id: p.id, nome: p.nome, hora: p.hora, speaker: p.speaker }]
      })
      this.grupos = this.grupos.filter(g => g !== grupo)
    })
  }

  private removePassengerLocal(from: GrupoUI, passageiroId: string) {
    // eslint-disable-next-line eqeqeq
    const p = from.passageiros.find(p => p.id == passageiroId)
    if (!p) return

    // eslint-disable-next-line eqeqeq
    from.passageiros = from.passageiros.filter(p => p.id != passageiroId)
    this.semCorrespondencia = [...this.semCorrespondencia, { id: p.id, nome: p.nome, hora: p.hora, speaker: p.speaker, motivo: 'Removido manualmente' }]
    from.totalPassageiros = from.passageiros.length
    this.updateGroupDateTime(from)
  }

  moverPassageiroSemCorrespondencia(passageiro: any): void {
    const ref = this.dialog.open(ModalMoverPassageiroComponent, {
      data: { passageiro, grupos: this.grupos },
      width: '480px',
      maxHeight: '80vh',
    })
    ref.afterClosed().subscribe((toGrupo: GrupoUI | null) => {
      if (!toGrupo) return
      // eslint-disable-next-line eqeqeq
      this.semCorrespondencia = this.semCorrespondencia.filter(p => p.id != passageiro.id)
      const pUI: PassageiroUI = {
        id: passageiro.id,
        nome: passageiro.nome,
        hora: passageiro.hora ?? '',
        data: passageiro.data,
        speaker: passageiro.speaker === 'S' || passageiro.speaker === 'SIM' || passageiro.speaker === true,
        multiploTrecho: passageiro.multiploTrecho ?? false,
        repetida: passageiro.repetida ?? false,
        origemTipo: passageiro.origemTipo || null,
        origemAeroSigla: passageiro.origemAeroSigla || null,
        origemLogradouro: passageiro.origemLogradouro || null,
        origemNumero: passageiro.origemNumero || null,
        origemComplemento: passageiro.origemComplemento || null,
        origemBairro: passageiro.origemBairro || null,
        origemCidade: passageiro.origemCidade || null,
        destinoTipo: passageiro.destinoTipo || null,
        destinoAeroSigla: passageiro.destinoAeroSigla || null,
        destinoLogradouro: passageiro.destinoLogradouro || null,
        destinoNumero: passageiro.destinoNumero || null,
        destinoComplemento: passageiro.destinoComplemento || null,
        destinoBairro: passageiro.destinoBairro || null,
        destinoCidade: passageiro.destinoCidade || null,
        rotaDivergente: passageiro.rotaDivergente ?? false,
      }
      toGrupo.passageiros = [...toGrupo.passageiros, pUI]
      toGrupo.totalPassageiros = toGrupo.passageiros.length
      this.updateGroupDateTime(toGrupo)
    })
  }

  private updateGroupDateTime(grupo: GrupoUI): void {
    if (grupo.passageiros.length === 0) return

    const horas = grupo.passageiros
      .map(p => p.hora)
      .filter(h => h && h !== '00:00:00' && h !== '00:00')
    if (horas.length > 0) {
      horas.sort()
      grupo.horaInicio = horas[0].substring(0, 5)
    }

    if (!grupo.data) {
      const pWithData = grupo.passageiros.find(p => p.data)
      if (pWithData) {
        grupo.data = pWithData.data!
      }
    }
  }

  formatEndereco(p: PassageiroUI, tipo: 'origem' | 'destino'): SafeHtml {
    const tipoEnd = tipo === 'origem' ? p.origemTipo : p.destinoTipo
    if (tipoEnd === 'AEROPORTO') {
      const sigla = tipo === 'origem' ? p.origemAeroSigla : p.destinoAeroSigla
      return this.sanitizer.bypassSecurityTrustHtml(sigla?.trim() || 'N/A')
    }
    const val = (v: string | null | undefined) => v?.trim() || null
    const logr = val(tipo === 'origem' ? p.origemLogradouro : p.destinoLogradouro)
    const num = val(tipo === 'origem' ? p.origemNumero : p.destinoNumero)
    const comp = val(tipo === 'origem' ? p.origemComplemento : p.destinoComplemento)
    const bairro = val(tipo === 'origem' ? p.origemBairro : p.destinoBairro)
    const cidade = val(tipo === 'origem' ? p.origemCidade : p.destinoCidade)

    const pre = [logr, num].filter(Boolean).join(', ')
    const post = [bairro, cidade].filter(Boolean).join(', ')
    const segments: string[] = []
    if (pre) segments.push(pre)
    if (comp) segments.push(`<strong>${comp}</strong>`)
    if (post) segments.push(post)

    return this.sanitizer.bypassSecurityTrustHtml(segments.length ? segments.join(', ') : 'N/A')
  }

  close() {
    this.dialogRef.close()
  }
}
